<template>
  <ContentLayout :smallHeader="file">
    <template #header>
      <span v-if="file" class="space-right">{{ title }}</span>
      <h4>Diversos</h4>
      <button v-if="file" class="btn space-left" @click="reset()">Voltar</button>
    </template>

    <div v-if="!file">
      <ul>
        <li v-for="(file, key) in files" :key="key" class="item" @click="showFile(file.name, file.title)">{{ file.title }}</li>
      </ul>
    </div>

    <pdf-viewer v-else :source="'./pdf/'+ file" />
  </ContentLayout>
</template>

<script>
import axios from 'axios';
import ContentLayout from '../components/ContentLayout';

export default {
  components: {
    ContentLayout
  },
  data: () => ({
    files: [],
    file: null,
    title: null
  }),
  methods: {
    showFile(file, title) {
      this.file = file;
      this.title = title;
    },
    reset() {
      this.file = null;
      this.title = null;
    },
    async getDiversos() {
      const response = await axios.get('./diversos.json');
      response.data.forEach(file => {
        this.files.push({
          title: file[0],
          name: file[1]
        })
      });
    }
  },
  mounted() {
    this.getDiversos();
  }
};
</script>

<style lang="scss" scoped>
.space-right {
  margin-right: auto;
}

.space-left {
  margin-left: auto;
}

.item {
  background: var(--color-orange);
  padding: 15px;
  margin-bottom: 5px;
  text-align: center;
  cursor: pointer;
}

.icon {
  height: 70px;
  border-radius: 50%;
}

ul {
  -moz-column-count: 2;
  -webkit-column-count: 2;
  column-count: 2;
}

li {
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid-column;
  list-style: none;
}

@media (max-width: 900px) {
  .space-right {
    flex-basis: 100%;
    order: 3;
  }
}
</style>
